<wr-new-data-table
  headerText="Wartungshistorie"
  localStorageIdentifier="maintenance-timer-history"
  [form]="filterForm"
  [loadItemsFunction]="loadMaintenanceTimerHistories"
  [getCountFunction]="getCount"
  [externalLoading$]="loading$"
  [defaultSort]="defaultSort"
  (lineClick)="navigateToHistoryDetail($event)"
>
  <ng-template dataTableFilter>
    <form [formGroup]="filterForm">

      @if (maintenanceTimerId() !== null) {
        <div class="active-filter-chip">
          <nb-icon pack="eva" icon="funnel-outline"></nb-icon>
          <span>Nach Timer gefiltert</span>
          <button nbButton ghost size="tiny" (click)="clearMaintenanceTimerId()" class="chip-clear-btn" nbTooltip="Filter entfernen">
            <nb-icon pack="eva" icon="close-outline"></nb-icon>
          </button>
        </div>
      }

      <div class="filter-items">

        <div class="filter-control-group">
          <label class="label" for="building">Gebäude</label>
          <wr-building-select id="building" formControlName="buildingId"></wr-building-select>
        </div>

        <div class="filter-control-group">
          <label class="label" for="buildingSectionName">Gebäudeteil</label>
          <input type="text" nbInput id="buildingSectionName" formControlName="buildingSectionName" placeholder="Gebäudeteil suchen">
        </div>

        <div class="filter-control-group">
          <label class="label" for="equipment">TGA</label>
          <wr-tga-type-select id="equipment" formControlName="equipmentId"></wr-tga-type-select>
        </div>

        <div class="filter-control-group">
          <label class="label" for="dateRange">Zeitraum</label>
          <wr-date-range-picker id="dateRange" formControlName="dateRange" [showTodayButton]="true"></wr-date-range-picker>
        </div>

        <div class="filter-control-group">
          <label class="label" for="finishedInTime">Rechtzeitig abgeschlossen</label>
          <nb-select id="finishedInTime" formControlName="finishedInTime" placeholder="Alle">
            <nb-option [value]="null">Alle</nb-option>
            <nb-option [value]="true">Ja</nb-option>
            <nb-option [value]="false">Nein</nb-option>
          </nb-select>
        </div>

        <div class="filter-control-group">
          <label class="label" for="overdueDaysMin">Min. Überfällige Tage</label>
          <input nbInput type="number" id="overdueDaysMin" formControlName="overdueDaysMin"/>
        </div>

      </div>
    </form>
  </ng-template>

  <ng-template dataColumn key="buildingSectionName" display="Gebäudeteil" let-row>
    {{ row.buildingSectionName }}
  </ng-template>

  <ng-template dataColumn key="buildingEquipmentName" display="TGA" let-row>
    {{ row.buildingEquipmentName }}
  </ng-template>

  <ng-template dataColumn key="maintenanceDate" display="Datum der Wartung" let-row>
    {{ row.maintenanceDate | date:'dd.MM.yyyy' }}
  </ng-template>

  <ng-template dataColumn key="finishedInTime" display="Status" let-row>
    <span class="status-chip" [class.status-chip--ok]="row.finishedInTime" [class.status-chip--late]="!row.finishedInTime">
      <nb-icon pack="eva" [icon]="row.finishedInTime ? 'checkmark-outline' : 'clock-outline'"></nb-icon>
      {{ row.finishedInTime ? 'Rechtzeitig' : (row.overdueDays > 0 ? row.overdueDays + ' Tage verspätet' : 'Verspätet') }}
    </span>
  </ng-template>

  <ng-template dataColumn key="finisherName" display="Durchgeführt von" let-row>
    {{ row.finisherName }}
  </ng-template>

  <ng-template dataColumn key="hasProtocol" [sortable]="false" display="Protokoll" let-row>
    @if (row.hasProtocol) {
      <span class="protocol-badge">
        <nb-icon pack="eva" icon="file-text-outline"></nb-icon>
        Protokoll
      </span>
    }
  </ng-template>

  <ng-template dataColumn let-row key="download" display="Download" [sortable]="false" [exportable]="false">
    <div class="download-buttons">
      <button nbButton status="basic" size="small" nbTooltip="Wartungsprotokoll herunterladen"
              (click)="onDownloadClick(row.id, $event)">
        <nb-icon pack="eva" icon="download-outline"></nb-icon>
      </button>
      @if (row.protocolId) {
        <button nbButton status="primary" size="small" nbTooltip="Protokoll PDF herunterladen"
                (click)="onProtocolDownloadClick(row.protocolId, $event)">
          <nb-icon pack="eva" icon="file-text-outline"></nb-icon>
        </button>
      }
    </div>
  </ng-template>

</wr-new-data-table>
